import React, { useState, useEffect } from 'react';
import {
  Box,
  Grid,
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Paper
} from '@mui/material';
import MainCard from '../../components/MainCard';
import Sidebar from "../../menu-items/Sidebar";
import axios from 'axios';
import Cookies from "js-cookie";

const Waitlist = () => {
  const [data, setData] = useState([]); 
  const [page, setPage] = useState(0); 
  const [rowsPerPage, setRowsPerPage] = useState(20); 
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);

      // Prefer your existing axios default Authorization, otherwise fall back to cookie if you use one
      const token =
        axios.defaults.headers.common.Authorization ||
        (Cookies.get("token") ? `Bearer ${Cookies.get("token")}` : undefined);

      const url = `${process.env.REACT_APP_BASE_URL}admin/reports/waitinglist`;

      const config = token
        ? { headers: { Authorization: token } }
        : undefined;

      try {
        const response = await axios.get(url, config);
        console.log('API Response:', response.data);

        // Your API returns { total, offset, limit, results: [...] }
        const items = Array.isArray(response?.data?.results)
          ? response.data.results
          : [];

        setData(items);
      } catch (error) {
        console.error('Error fetching data:', error);
        setData([]);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const downloadAsCSV = () => {
    const headers = ['#', 'Email', 'Created At', 'Role'];
    const csvRows = [headers.join(',')];

    data.forEach((row, index) => {
      const rowData = [
        index + 1,
        row?.email ?? '',
        row?.created_at ?? '',
        row?.role ?? ''
      ];
      // Basic CSV escaping
      csvRows.push(rowData.map((v) => `"${String(v).replace(/"/g, '""')}"`).join(','));
    });

    const csvData = csvRows.join('\n');
    const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = 'waitlist.csv';
    link.click();
  };

  const handleChangePage = (_event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const displayedData = data.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  return (
    <Box sx={{ border: '1px solid #ccc', padding: 5, minHeight: '100vh' }}>
      <Grid container rowSpacing={2.5} columnSpacing={2.75}>
        <Grid item xs={12} md={3} lg={2}>
          <Sidebar />
        </Grid>

        <Grid item xs={12} md={9} lg={10}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography
              variant="h4"
              sx={{ fontWeight: 'bold', fontSize: '2rem' }}
            >
              Waiting list
            </Typography>

            <Button
              variant="contained"
              color="primary"
              sx={{ marginLeft: 2 }}
              onClick={downloadAsCSV}
              disabled={data.length === 0}
            >
              Download as CSV
            </Button>
          </Box>

          <MainCard title="">
            <TableContainer
              component={Paper}
              sx={{
                borderRadius: '15px',
                boxShadow: 3,
                overflow: 'hidden',
                marginTop: 2,
              }}
            >
              <Table sx={{ borderCollapse: 'separate', borderSpacing: 0 }}>
                <TableHead>
                  <TableRow sx={{ backgroundColor: '#1976d2' }}>
                    <TableCell sx={{ fontWeight: 'bold', color: '#fff' }}>#</TableCell>
                    <TableCell sx={{ fontWeight: 'bold', color: '#fff' }}>Email</TableCell>
                    <TableCell sx={{ fontWeight: 'bold', color: '#fff' }}>Created At</TableCell>
                    <TableCell sx={{ fontWeight: 'bold', color: '#fff' }}>Role</TableCell>
                    <TableCell sx={{ fontWeight: 'bold', color: '#fff' }}>Actions</TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {loading ? (
                    <TableRow>
                      <TableCell colSpan={5} align="center">
                        Loading...
                      </TableCell>
                    </TableRow>
                  ) : displayedData.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={5} align="center">
                        No data available
                      </TableCell>
                    </TableRow>
                  ) : (
                    displayedData.map((row, index) => (
                      <TableRow
                        key={`${row.email}-${index}`}
                        sx={{
                          '&:hover': { backgroundColor: '#f5f5f5', cursor: 'pointer' },
                          borderBottom: '1px solid #ddd',
                        }}
                      >
                        <TableCell sx={{ borderTopLeftRadius: index === 0 ? '15px' : '0px' }}>
                          {page * rowsPerPage + index + 1}
                        </TableCell>

                        <TableCell>
                          {row?.email ?? '-'}
                         
                        </TableCell>

                        <TableCell>{row?.created_at ?? '-'}</TableCell>
                        <TableCell>{row?.role ?? '-'}</TableCell>

                        <TableCell>
                          <Button
                            variant="contained"
                            size="small"
                            sx={{ marginLeft: 1 }}
                            onClick={() => {
                              if (row?.email) {
                                window.location.href = `mailto:${row.email}`;
                              }
                            }}
                          >
                            Contact
                          </Button>
                        </TableCell>
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>

            <TablePagination
              rowsPerPageOptions={[20, 50, 100, 200]}
              component="div"
              count={data.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </MainCard>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Waitlist;